import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCircleRight, faLock, faLockOpen} from "@fortawesome/pro-solid-svg-icons";
import {
    ProjectLockDialogShowerContext,
    ProjectLockDialogShowerContextProps
} from "@/pages/takeoff/context/project-lock-dialog-shower/project-lock-dialog-shower-context-props.ts";
import useProjectContext from "@/services/context/project/use-project-context.ts";
import ClosableDialog from "@/components/dialogs/closable-dialog";
import ProjectLockStatus from "@/models/enums/project-lock-status";
import Button from "@/components/buttons/button";

const ProjectLockDialogShowerProvider: React.FC<React.PropsWithChildren> = ({children}) => {
    const {project, projectLockStatus, lockProject} = useProjectContext();
    
    const [showLockDialog, setShowLockDialog] = useState(false);
    const [isModifyHovered, setIsModifyHovered] = useState(false);

    const contextProps: ProjectLockDialogShowerContextProps = {
        showLockDialog,
        setShowLockDialog
    }
    
    return (
        <ProjectLockDialogShowerContext.Provider value={contextProps}>
            <>
                {children}

                <ClosableDialog open={showLockDialog} onClose={() => setShowLockDialog(false)} title='Modifications'>
                    <div className='mt-2 text-gray-700'>
                        {projectLockStatus === ProjectLockStatus.LOCK ? (
                            <div className='flex flex-col gap-y-2'>
                                <span>Le projet est verrouillé par {project.projectLock?.userLockEmail}.</span>
                                <span>Vous ne pouvez pas le modifier.</span>
                            </div>
                        ) : (
                            <div className='flex flex-row gap-x-4 items-center'>
                                <div className='flex flex-col gap-y-2 flex-1'>
                                    <span>Le projet n’est pas verrouillé.</span>
                                    <span>Prenez le lock pour pouvoir le modifier.</span>
                                </div>
                                <FontAwesomeIcon icon={faCircleRight} className='text-xl' />
                                <Button variant={isModifyHovered ? 'danger' : 'success'}
                                        className='transition-all duration-200 ease-in-out'
                                        onMouseEnter={() => setIsModifyHovered(true)}
                                        onMouseLeave={() => setIsModifyHovered(false)}
                                        onClick={() => {
                                            lockProject();
                                            setShowLockDialog(false);
                                        }}>
                                <span className="relative inline-flex size-8 text-xl items-center justify-center">
                                    <FontAwesomeIcon
                                        icon={faLockOpen}
                                        className={`absolute transition-all duration-200 ease-in-out ${isModifyHovered ? "opacity-0 scale-90 rotate-12" : "opacity-100 scale-100 rotate-0"}`}
                                    />
                                    <FontAwesomeIcon
                                        icon={faLock}
                                        className={`absolute transition-all duration-200 ease-in-out ${isModifyHovered ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-90 -rotate-12" }`}
                                    />
                                </span>
                                </Button>
                            </div>
                        )}
                    </div>
                </ClosableDialog>
            </>
        </ProjectLockDialogShowerContext.Provider>
    )
}

export default ProjectLockDialogShowerProvider;